import { createQueryKeys } from '@lukemorales/query-key-factory';

import { getDigitalCoaches, getDigitalCoachProfile } from '../api/';

export const digitalCoachesKeys = createQueryKeys('digitalCoaches', {
  list: {
    queryKey: null,
    queryFn: (options) => getDigitalCoaches(options),
  },
  me: {
    queryKey: null,
    queryFn: (options) => getDigitalCoachProfile(options),
  },
});
